const constants = {
    themeModes: {
        light: "light",
        dark: "dark"
    },
    serverResponseIdentifier: ["QHSCQKXZZRNGMRPB", "UQSAVFVKPJDGJCCJ"]
}

export default constants